import { render, staticRenderFns } from "./ErpVoucherForm.vue?vue&type=template&id=210465c7"
import script from "./ErpVoucherForm.vue?vue&type=script&lang=ts"
export * from "./ErpVoucherForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports